"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workLocations = void 0;
var paginateAnything_1 = require("../../../functions/util/paginateAnything");
exports.workLocations = paginateAnything_1.paginateAnything([
    {
        content: {
            id: 26972,
            locationId: "L1231",
            locationType: "Industrial",
            name: "14TH ST TOWER",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: null,
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:04.148508Z",
        },
        dataSourceId: 1300,
        id: 26972,
        softDeleted: false,
        source: "API",
        uniqueId: "L1231",
    },
    {
        content: {
            id: 26986,
            locationId: "L2084",
            locationType: "Junction",
            name: "502 JUNCTION",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 39.201412,
                longitude: -79.271041,
                valid: true,
                gpsString: "(39.201412, -79.271041)",
            },
            region: null,
            physicalAddress: null,
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:05.096911Z",
        },
        dataSourceId: 1300,
        id: 26986,
        softDeleted: false,
        source: "API",
        uniqueId: "L2084",
    },
    {
        content: {
            id: 26973,
            locationId: "L1232",
            locationType: "Industrial",
            name: "8TH & MAIN TOWER2",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: null,
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:04.179726Z",
        },
        dataSourceId: 1300,
        id: 26973,
        softDeleted: false,
        source: "API",
        uniqueId: "L1232",
    },
    {
        content: {
            id: 26765,
            locationId: "L0344",
            locationType: "Industrial",
            name: "ABBOTT IND SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 36.032885,
                longitude: -77.766152,
                valid: true,
                gpsString: "(36.032885, -77.766152)",
            },
            region: null,
            physicalAddress: {
                id: 501825,
                line1: "4285  WESLEYAN BLVD",
                line2: null,
                line3: null,
                city: "BATTLEBORO",
                state: "NC",
                zip: "27809",
                addressString: "4285  WESLEYAN BLVD, BATTLEBORO, NC 27809",
            },
            emergencyAddress: null,
            supervisor: {
                id: 26405,
                email: "ronald.e.betts@dominionenergy.com",
                firstName: "Ronald",
                lastName: "Betts",
                nickname: null,
                workLocation: null,
                supervisor: {
                    id: 38721,
                    email: "thomas.e.imel@dominionenergy.com",
                    firstName: "Thomas",
                    lastName: "Imel",
                    nickname: null,
                    workLocation: {
                        id: 33804,
                        locationId: "RICH GRAYLAND A",
                        locationType: null,
                        name: "Unknown",
                        nickname: null,
                        locationInformationUrl: null,
                        preferUsersLocation: null,
                        geolocation: null,
                        region: null,
                        physicalAddress: null,
                        emergencyAddress: null,
                        supervisor: null,
                        softDeleted: true,
                        source: "API_INCOMPLETE",
                        dataSourceId: 1350,
                        lastModifiedDate: "2020-05-05T23:02:24.252472Z",
                    },
                    supervisor: {
                        id: 1465,
                        email: "robert.f.martin@dominionenergy.com",
                        firstName: "Robert",
                        lastName: "Martin",
                        nickname: null,
                        workLocation: null,
                        supervisor: null,
                        softDeleted: false,
                        dataSourceId: 2002,
                        source: "API",
                        clientGroups: [],
                        teams: [],
                        contractingCompany: null,
                        primaryGroupId: null,
                        participantType: "EMPLOYEE",
                        lastModifiedDate: "2021-03-16T04:01:14.891943Z",
                        fullName: "Martin, Robert",
                        name: "Robert Martin",
                    },
                    softDeleted: false,
                    dataSourceId: 2002,
                    source: "API",
                    clientGroups: [],
                    teams: [],
                    contractingCompany: null,
                    primaryGroupId: null,
                    participantType: "EMPLOYEE",
                    lastModifiedDate: "2021-03-16T04:01:19.579295Z",
                    fullName: "Imel, Thomas",
                    name: "Thomas Imel",
                },
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-03-31T04:00:38.786305Z",
                fullName: "Betts, Ronald",
                name: "Ronald Betts",
            },
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:10:54.464663Z",
        },
        dataSourceId: 1300,
        id: 26765,
        softDeleted: false,
        source: "API",
        uniqueId: "L0344",
    },
    {
        content: {
            id: 27413,
            locationId: "L0345",
            locationType: "Substation",
            name: "ACADEMY SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 36.294275,
                longitude: -76.986316,
                valid: true,
                gpsString: "(36.294275, -76.986316)",
            },
            region: null,
            physicalAddress: {
                id: 502116,
                line1: "NORTH ACADEMY ST",
                line2: null,
                line3: null,
                city: "AHOSKIE",
                state: "NC",
                zip: "27910",
                addressString: "NORTH ACADEMY ST, AHOSKIE, NC 27910",
            },
            emergencyAddress: null,
            supervisor: {
                id: 26408,
                email: "donald.v.joyner@dominionenergy.com",
                firstName: "Donald",
                lastName: "Joyner",
                nickname: null,
                workLocation: null,
                supervisor: {
                    id: 26405,
                    email: "ronald.e.betts@dominionenergy.com",
                    firstName: "Ronald",
                    lastName: "Betts",
                    nickname: null,
                    workLocation: {
                        id: 34134,
                        locationId: "PORTSMOUTH DIST",
                        locationType: null,
                        name: "Unknown",
                        nickname: null,
                        locationInformationUrl: null,
                        preferUsersLocation: null,
                        geolocation: null,
                        region: null,
                        physicalAddress: null,
                        emergencyAddress: null,
                        supervisor: null,
                        softDeleted: true,
                        source: "API_INCOMPLETE",
                        dataSourceId: 1350,
                        lastModifiedDate: "2020-05-05T23:02:13.476719Z",
                    },
                    supervisor: {
                        id: 38721,
                        email: "thomas.e.imel@dominionenergy.com",
                        firstName: "Thomas",
                        lastName: "Imel",
                        nickname: null,
                        workLocation: null,
                        supervisor: null,
                        softDeleted: false,
                        dataSourceId: 2002,
                        source: "API",
                        clientGroups: [],
                        teams: [],
                        contractingCompany: null,
                        primaryGroupId: null,
                        participantType: "EMPLOYEE",
                        lastModifiedDate: "2021-03-16T04:01:19.579295Z",
                        fullName: "Imel, Thomas",
                        name: "Thomas Imel",
                    },
                    softDeleted: false,
                    dataSourceId: 2002,
                    source: "API",
                    clientGroups: [],
                    teams: [],
                    contractingCompany: null,
                    primaryGroupId: null,
                    participantType: "EMPLOYEE",
                    lastModifiedDate: "2021-03-31T04:00:38.786305Z",
                    fullName: "Betts, Ronald",
                    name: "Ronald Betts",
                },
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-03-16T04:00:54.666516Z",
                fullName: "Joyner, Donald",
                name: "Donald Joyner",
            },
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:21.000215Z",
        },
        dataSourceId: 1300,
        id: 27413,
        softDeleted: false,
        source: "API",
        uniqueId: "L0345",
    },
    {
        content: {
            id: 27145,
            locationId: "L0018",
            locationType: "Substation",
            name: "ACCA SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 37.579909,
                longitude: -77.477002,
                valid: true,
                gpsString: "(37.579909, -77.477002)",
            },
            region: null,
            physicalAddress: {
                id: 501999,
                line1: "85 WESTWOOD TRL",
                line2: null,
                line3: null,
                city: "RICHMOND",
                state: "VA",
                zip: "23230",
                addressString: "85 WESTWOOD TRL, RICHMOND, VA 23230",
            },
            emergencyAddress: null,
            supervisor: {
                id: 26410,
                email: "gil.arthur@dominionenergy.com",
                firstName: "James",
                lastName: "Arthur",
                nickname: null,
                workLocation: null,
                supervisor: {
                    id: 33913,
                    email: "gordon.peter.martin@dominionenergy.com",
                    firstName: "Gordon",
                    lastName: "Martin",
                    nickname: null,
                    workLocation: {
                        id: 34117,
                        locationId: "EAST RICHMOND",
                        locationType: null,
                        name: "Unknown",
                        nickname: null,
                        locationInformationUrl: null,
                        preferUsersLocation: null,
                        geolocation: null,
                        region: null,
                        physicalAddress: null,
                        emergencyAddress: null,
                        supervisor: null,
                        softDeleted: true,
                        source: "API_INCOMPLETE",
                        dataSourceId: 1350,
                        lastModifiedDate: "2020-05-05T23:02:24.110237Z",
                    },
                    supervisor: {
                        id: 38721,
                        email: "thomas.e.imel@dominionenergy.com",
                        firstName: "Thomas",
                        lastName: "Imel",
                        nickname: null,
                        workLocation: null,
                        supervisor: null,
                        softDeleted: false,
                        dataSourceId: 2002,
                        source: "API",
                        clientGroups: [],
                        teams: [],
                        contractingCompany: null,
                        primaryGroupId: null,
                        participantType: "EMPLOYEE",
                        lastModifiedDate: "2021-03-16T04:01:19.579295Z",
                        fullName: "Imel, Thomas",
                        name: "Thomas Imel",
                    },
                    softDeleted: false,
                    dataSourceId: 2002,
                    source: "API",
                    clientGroups: [],
                    teams: [],
                    contractingCompany: null,
                    primaryGroupId: null,
                    participantType: "EMPLOYEE",
                    lastModifiedDate: "2021-03-16T04:00:57.808671Z",
                    fullName: "Martin, Gordon",
                    name: "Gordon Martin",
                },
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-03-16T04:00:59.260030Z",
                fullName: "Arthur, James",
                name: "James Arthur",
            },
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:12.595316Z",
        },
        dataSourceId: 1300,
        id: 27145,
        softDeleted: false,
        source: "API",
        uniqueId: "L0018",
    },
    {
        content: {
            id: 29184,
            locationId: "L2433",
            locationType: "Substation",
            name: "ACORN HILL SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: {
                id: 502661,
                line1: "346 BOSLEY RD",
                line2: null,
                line3: null,
                city: "SUNBURY",
                state: "NC",
                zip: "27979",
                addressString: "346 BOSLEY RD, SUNBURY, NC 27979",
            },
            emergencyAddress: null,
            supervisor: {
                id: 26408,
                email: "donald.v.joyner@dominionenergy.com",
                firstName: "Donald",
                lastName: "Joyner",
                nickname: null,
                workLocation: null,
                supervisor: {
                    id: 26405,
                    email: "ronald.e.betts@dominionenergy.com",
                    firstName: "Ronald",
                    lastName: "Betts",
                    nickname: null,
                    workLocation: {
                        id: 34134,
                        locationId: "PORTSMOUTH DIST",
                        locationType: null,
                        name: "Unknown",
                        nickname: null,
                        locationInformationUrl: null,
                        preferUsersLocation: null,
                        geolocation: null,
                        region: null,
                        physicalAddress: null,
                        emergencyAddress: null,
                        supervisor: null,
                        softDeleted: true,
                        source: "API_INCOMPLETE",
                        dataSourceId: 1350,
                        lastModifiedDate: "2020-05-05T23:02:13.476719Z",
                    },
                    supervisor: {
                        id: 38721,
                        email: "thomas.e.imel@dominionenergy.com",
                        firstName: "Thomas",
                        lastName: "Imel",
                        nickname: null,
                        workLocation: null,
                        supervisor: null,
                        softDeleted: false,
                        dataSourceId: 2002,
                        source: "API",
                        clientGroups: [],
                        teams: [],
                        contractingCompany: null,
                        primaryGroupId: null,
                        participantType: "EMPLOYEE",
                        lastModifiedDate: "2021-03-16T04:01:19.579295Z",
                        fullName: "Imel, Thomas",
                        name: "Thomas Imel",
                    },
                    softDeleted: false,
                    dataSourceId: 2002,
                    source: "API",
                    clientGroups: [],
                    teams: [],
                    contractingCompany: null,
                    primaryGroupId: null,
                    participantType: "EMPLOYEE",
                    lastModifiedDate: "2021-03-31T04:00:38.786305Z",
                    fullName: "Betts, Ronald",
                    name: "Ronald Betts",
                },
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-03-16T04:00:54.666516Z",
                fullName: "Joyner, Donald",
                name: "Donald Joyner",
            },
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:12:43.334315Z",
        },
        dataSourceId: 1300,
        id: 29184,
        softDeleted: false,
        source: "API",
        uniqueId: "L2433",
    },
    {
        content: {
            id: 29266,
            locationId: "L2536",
            locationType: "Substation",
            name: "AGATE SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: null,
            emergencyAddress: null,
            supervisor: {
                id: 26408,
                email: "donald.v.joyner@dominionenergy.com",
                firstName: "Donald",
                lastName: "Joyner",
                nickname: null,
                workLocation: null,
                supervisor: {
                    id: 26405,
                    email: "ronald.e.betts@dominionenergy.com",
                    firstName: "Ronald",
                    lastName: "Betts",
                    nickname: null,
                    workLocation: {
                        id: 34134,
                        locationId: "PORTSMOUTH DIST",
                        locationType: null,
                        name: "Unknown",
                        nickname: null,
                        locationInformationUrl: null,
                        preferUsersLocation: null,
                        geolocation: null,
                        region: null,
                        physicalAddress: null,
                        emergencyAddress: null,
                        supervisor: null,
                        softDeleted: true,
                        source: "API_INCOMPLETE",
                        dataSourceId: 1350,
                        lastModifiedDate: "2020-05-05T23:02:13.476719Z",
                    },
                    supervisor: {
                        id: 38721,
                        email: "thomas.e.imel@dominionenergy.com",
                        firstName: "Thomas",
                        lastName: "Imel",
                        nickname: null,
                        workLocation: null,
                        supervisor: null,
                        softDeleted: false,
                        dataSourceId: 2002,
                        source: "API",
                        clientGroups: [],
                        teams: [],
                        contractingCompany: null,
                        primaryGroupId: null,
                        participantType: "EMPLOYEE",
                        lastModifiedDate: "2021-03-16T04:01:19.579295Z",
                        fullName: "Imel, Thomas",
                        name: "Thomas Imel",
                    },
                    softDeleted: false,
                    dataSourceId: 2002,
                    source: "API",
                    clientGroups: [],
                    teams: [],
                    contractingCompany: null,
                    primaryGroupId: null,
                    participantType: "EMPLOYEE",
                    lastModifiedDate: "2021-03-31T04:00:38.786305Z",
                    fullName: "Betts, Ronald",
                    name: "Ronald Betts",
                },
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-03-16T04:00:54.666516Z",
                fullName: "Joyner, Donald",
                name: "Donald Joyner",
            },
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:12:45.552723Z",
        },
        dataSourceId: 1300,
        id: 29266,
        softDeleted: false,
        source: "API",
        uniqueId: "L2536",
    },
    {
        content: {
            id: 502751,
            locationId: "01",
            locationType: "District Office",
            name: "Ahoskie Construction",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: null,
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1301,
            lastModifiedDate: "2020-06-24T01:12:47.849982Z",
        },
        dataSourceId: 1301,
        id: 502751,
        softDeleted: false,
        source: "API",
        uniqueId: "01",
    },
    {
        content: {
            id: 27042,
            locationId: "L0465",
            locationType: "Office",
            name: "AHOSKIE OFC",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: {
                id: 1205077,
                line1: "INTERSECT OH HWY 11 & 461",
                line2: null,
                line3: null,
                city: "AHOSKIE",
                state: "NC",
                zip: "27910",
                addressString: "INTERSECT OH HWY 11 & 461, AHOSKIE, NC 27910",
            },
            emergencyAddress: null,
            supervisor: {
                id: 26408,
                email: "donald.v.joyner@dominionenergy.com",
                firstName: "Donald",
                lastName: "Joyner",
                nickname: null,
                workLocation: null,
                supervisor: {
                    id: 26405,
                    email: "ronald.e.betts@dominionenergy.com",
                    firstName: "Ronald",
                    lastName: "Betts",
                    nickname: null,
                    workLocation: {
                        id: 34134,
                        locationId: "PORTSMOUTH DIST",
                        locationType: null,
                        name: "Unknown",
                        nickname: null,
                        locationInformationUrl: null,
                        preferUsersLocation: null,
                        geolocation: null,
                        region: null,
                        physicalAddress: null,
                        emergencyAddress: null,
                        supervisor: null,
                        softDeleted: true,
                        source: "API_INCOMPLETE",
                        dataSourceId: 1350,
                        lastModifiedDate: "2020-05-05T23:02:13.476719Z",
                    },
                    supervisor: {
                        id: 38721,
                        email: "thomas.e.imel@dominionenergy.com",
                        firstName: "Thomas",
                        lastName: "Imel",
                        nickname: null,
                        workLocation: null,
                        supervisor: null,
                        softDeleted: false,
                        dataSourceId: 2002,
                        source: "API",
                        clientGroups: [],
                        teams: [],
                        contractingCompany: null,
                        primaryGroupId: null,
                        participantType: "EMPLOYEE",
                        lastModifiedDate: "2021-03-16T04:01:19.579295Z",
                        fullName: "Imel, Thomas",
                        name: "Thomas Imel",
                    },
                    softDeleted: false,
                    dataSourceId: 2002,
                    source: "API",
                    clientGroups: [],
                    teams: [],
                    contractingCompany: null,
                    primaryGroupId: null,
                    participantType: "EMPLOYEE",
                    lastModifiedDate: "2021-03-31T04:00:38.786305Z",
                    fullName: "Betts, Ronald",
                    name: "Ronald Betts",
                },
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-03-16T04:00:54.666516Z",
                fullName: "Joyner, Donald",
                name: "Donald Joyner",
            },
            softDeleted: false,
            source: "API",
            dataSourceId: 1301,
            lastModifiedDate: "2021-08-02T04:00:30.143080Z",
        },
        dataSourceId: 1301,
        id: 27042,
        softDeleted: false,
        source: "API",
        uniqueId: "L0465",
    },
    {
        content: {
            id: 502819,
            locationId: "82",
            locationType: "District Office",
            name: "Ahoskie Operations",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: null,
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1301,
            lastModifiedDate: "2020-06-24T01:12:50.460659Z",
        },
        dataSourceId: 1301,
        id: 502819,
        softDeleted: false,
        source: "API",
        uniqueId: "82",
    },
    {
        content: {
            id: 27505,
            locationId: "L0433",
            locationType: "Substation",
            name: "AHOSKIE SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 36.304367,
                longitude: -76.987103,
                valid: true,
                gpsString: "(36.304367, -76.987103)",
            },
            region: null,
            physicalAddress: {
                id: 502157,
                line1: "HWY 13",
                line2: null,
                line3: null,
                city: "COLFIELD",
                state: "NC",
                zip: "27910",
                addressString: "HWY 13, COLFIELD, NC 27910",
            },
            emergencyAddress: null,
            supervisor: {
                id: 26408,
                email: "donald.v.joyner@dominionenergy.com",
                firstName: "Donald",
                lastName: "Joyner",
                nickname: null,
                workLocation: null,
                supervisor: {
                    id: 26405,
                    email: "ronald.e.betts@dominionenergy.com",
                    firstName: "Ronald",
                    lastName: "Betts",
                    nickname: null,
                    workLocation: {
                        id: 34134,
                        locationId: "PORTSMOUTH DIST",
                        locationType: null,
                        name: "Unknown",
                        nickname: null,
                        locationInformationUrl: null,
                        preferUsersLocation: null,
                        geolocation: null,
                        region: null,
                        physicalAddress: null,
                        emergencyAddress: null,
                        supervisor: null,
                        softDeleted: true,
                        source: "API_INCOMPLETE",
                        dataSourceId: 1350,
                        lastModifiedDate: "2020-05-05T23:02:13.476719Z",
                    },
                    supervisor: {
                        id: 38721,
                        email: "thomas.e.imel@dominionenergy.com",
                        firstName: "Thomas",
                        lastName: "Imel",
                        nickname: null,
                        workLocation: null,
                        supervisor: null,
                        softDeleted: false,
                        dataSourceId: 2002,
                        source: "API",
                        clientGroups: [],
                        teams: [],
                        contractingCompany: null,
                        primaryGroupId: null,
                        participantType: "EMPLOYEE",
                        lastModifiedDate: "2021-03-16T04:01:19.579295Z",
                        fullName: "Imel, Thomas",
                        name: "Thomas Imel",
                    },
                    softDeleted: false,
                    dataSourceId: 2002,
                    source: "API",
                    clientGroups: [],
                    teams: [],
                    contractingCompany: null,
                    primaryGroupId: null,
                    participantType: "EMPLOYEE",
                    lastModifiedDate: "2021-03-31T04:00:38.786305Z",
                    fullName: "Betts, Ronald",
                    name: "Ronald Betts",
                },
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-03-16T04:00:54.666516Z",
                fullName: "Joyner, Donald",
                name: "Donald Joyner",
            },
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:24.145604Z",
        },
        dataSourceId: 1300,
        id: 27505,
        softDeleted: false,
        source: "API",
        uniqueId: "L0433",
    },
    {
        content: {
            id: 27514,
            locationId: "L0496",
            locationType: "Substation",
            name: "AIRLINE SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 36.822996,
                longitude: -76.338858,
                valid: true,
                gpsString: "(36.822996, -76.338858)",
            },
            region: null,
            physicalAddress: {
                id: 502166,
                line1: "1400  MASCOT ST",
                line2: null,
                line3: null,
                city: "PORTSMOUTH",
                state: "VA",
                zip: "23707",
                addressString: "1400  MASCOT ST, PORTSMOUTH, VA 23707",
            },
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:25.203572Z",
        },
        dataSourceId: 1300,
        id: 27514,
        softDeleted: false,
        source: "API",
        uniqueId: "L0496",
    },
    {
        content: {
            id: 26656,
            locationId: "L2093",
            locationType: "Delivery Point",
            name: "AIRPORT DP",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 38.74065,
                longitude: -77.50818,
                valid: true,
                gpsString: "(38.740650, -77.508180)",
            },
            region: null,
            physicalAddress: {
                id: 501771,
                line1: "9898 GODWIN DR",
                line2: null,
                line3: null,
                city: "MANASSAS",
                state: "VA",
                zip: "20110",
                addressString: "9898 GODWIN DR, MANASSAS, VA 20110",
            },
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:10:50.876344Z",
        },
        dataSourceId: 1300,
        id: 26656,
        softDeleted: false,
        source: "API",
        uniqueId: "L2093",
    },
    {
        content: {
            id: 502752,
            locationId: "02",
            locationType: "District Office",
            name: "Albemarle Construction",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: null,
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1301,
            lastModifiedDate: "2020-06-24T01:12:47.897685Z",
        },
        dataSourceId: 1301,
        id: 502752,
        softDeleted: false,
        source: "API",
        uniqueId: "02",
    },
    {
        content: {
            id: 502820,
            locationId: "83",
            locationType: "District Office",
            name: "Albemarle Operations",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: null,
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1301,
            lastModifiedDate: "2020-06-24T01:12:50.490805Z",
        },
        dataSourceId: 1301,
        id: 502820,
        softDeleted: false,
        source: "API",
        uniqueId: "83",
    },
    {
        content: {
            id: 27414,
            locationId: "L0346",
            locationType: "Substation",
            name: "ALBEMARLE SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 36.043395,
                longitude: -77.001465,
                valid: true,
                gpsString: "(36.043395, -77.001465)",
            },
            region: null,
            physicalAddress: {
                id: 502117,
                line1: "529 REPUBLICAN & SCHOO",
                line2: null,
                line3: null,
                city: "WINDSOR",
                state: "NC",
                zip: "27983",
                addressString: "529 REPUBLICAN & SCHOO, WINDSOR, NC 27983",
            },
            emergencyAddress: null,
            supervisor: {
                id: 26408,
                email: "donald.v.joyner@dominionenergy.com",
                firstName: "Donald",
                lastName: "Joyner",
                nickname: null,
                workLocation: null,
                supervisor: {
                    id: 26405,
                    email: "ronald.e.betts@dominionenergy.com",
                    firstName: "Ronald",
                    lastName: "Betts",
                    nickname: null,
                    workLocation: {
                        id: 34134,
                        locationId: "PORTSMOUTH DIST",
                        locationType: null,
                        name: "Unknown",
                        nickname: null,
                        locationInformationUrl: null,
                        preferUsersLocation: null,
                        geolocation: null,
                        region: null,
                        physicalAddress: null,
                        emergencyAddress: null,
                        supervisor: null,
                        softDeleted: true,
                        source: "API_INCOMPLETE",
                        dataSourceId: 1350,
                        lastModifiedDate: "2020-05-05T23:02:13.476719Z",
                    },
                    supervisor: {
                        id: 38721,
                        email: "thomas.e.imel@dominionenergy.com",
                        firstName: "Thomas",
                        lastName: "Imel",
                        nickname: null,
                        workLocation: null,
                        supervisor: null,
                        softDeleted: false,
                        dataSourceId: 2002,
                        source: "API",
                        clientGroups: [],
                        teams: [],
                        contractingCompany: null,
                        primaryGroupId: null,
                        participantType: "EMPLOYEE",
                        lastModifiedDate: "2021-03-16T04:01:19.579295Z",
                        fullName: "Imel, Thomas",
                        name: "Thomas Imel",
                    },
                    softDeleted: false,
                    dataSourceId: 2002,
                    source: "API",
                    clientGroups: [],
                    teams: [],
                    contractingCompany: null,
                    primaryGroupId: null,
                    participantType: "EMPLOYEE",
                    lastModifiedDate: "2021-03-31T04:00:38.786305Z",
                    fullName: "Betts, Ronald",
                    name: "Ronald Betts",
                },
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-03-16T04:00:54.666516Z",
                fullName: "Joyner, Donald",
                name: "Donald Joyner",
            },
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:21.053418Z",
        },
        dataSourceId: 1300,
        id: 27414,
        softDeleted: false,
        source: "API",
        uniqueId: "L0346",
    },
    {
        content: {
            id: 26890,
            locationId: "L0932",
            locationType: "Industrial",
            name: "ALDERMAN SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 38.036774,
                longitude: -78.514537,
                valid: true,
                gpsString: "(38.036774, -78.514537)",
            },
            region: null,
            physicalAddress: {
                id: 501898,
                line1: "484 PRATT DR",
                line2: null,
                line3: null,
                city: "CHARLOTTESVILLE",
                state: "VA",
                zip: "22903",
                addressString: "484 PRATT DR, CHARLOTTESVILLE, VA 22903",
            },
            emergencyAddress: null,
            supervisor: {
                id: 26407,
                email: "michael.e.poe@dominionenergy.com",
                firstName: "Michael",
                lastName: "Poe",
                nickname: null,
                workLocation: null,
                supervisor: {
                    id: 34496,
                    email: "lawrence.t.williams@dominionenergy.com",
                    firstName: "Lawrence",
                    lastName: "Williams",
                    nickname: null,
                    workLocation: {
                        id: 33808,
                        locationId: "LINCOLN PARK 2",
                        locationType: null,
                        name: "Unknown",
                        nickname: null,
                        locationInformationUrl: null,
                        preferUsersLocation: null,
                        geolocation: null,
                        region: null,
                        physicalAddress: null,
                        emergencyAddress: null,
                        supervisor: null,
                        softDeleted: true,
                        source: "API_INCOMPLETE",
                        dataSourceId: 1350,
                        lastModifiedDate: "2020-05-05T23:02:24.071545Z",
                    },
                    supervisor: {
                        id: 38721,
                        email: "thomas.e.imel@dominionenergy.com",
                        firstName: "Thomas",
                        lastName: "Imel",
                        nickname: null,
                        workLocation: null,
                        supervisor: null,
                        softDeleted: false,
                        dataSourceId: 2002,
                        source: "API",
                        clientGroups: [],
                        teams: [],
                        contractingCompany: null,
                        primaryGroupId: null,
                        participantType: "EMPLOYEE",
                        lastModifiedDate: "2021-03-16T04:01:19.579295Z",
                        fullName: "Imel, Thomas",
                        name: "Thomas Imel",
                    },
                    softDeleted: false,
                    dataSourceId: 2002,
                    source: "API",
                    clientGroups: [],
                    teams: [],
                    contractingCompany: null,
                    primaryGroupId: null,
                    participantType: "EMPLOYEE",
                    lastModifiedDate: "2021-03-16T04:01:07.703408Z",
                    fullName: "Williams, Lawrence",
                    name: "Lawrence Williams",
                },
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-03-16T04:01:10.683853Z",
                fullName: "Poe, Michael",
                name: "Michael Poe",
            },
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:01.086678Z",
        },
        dataSourceId: 1300,
        id: 26890,
        softDeleted: false,
        source: "API",
        uniqueId: "L0932",
    },
    {
        content: {
            id: 27515,
            locationId: "L0497",
            locationType: "Substation",
            name: "ALEXANDERS CORNER SUB",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: {
                latitude: 38.811233,
                longitude: -76.362978,
                valid: true,
                gpsString: "(38.811233, -76.362978)",
            },
            region: null,
            physicalAddress: {
                id: 502167,
                line1: "2909 BALLARD AVE",
                line2: "NEAR LAIGH RD",
                line3: null,
                city: "PORTSMOUTH",
                state: "VA",
                zip: "23701",
                addressString: "2909 BALLARD AVE NEAR LAIGH RD, PORTSMOUTH, VA 23701",
            },
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1300,
            lastModifiedDate: "2020-06-24T01:11:25.255139Z",
        },
        dataSourceId: 1300,
        id: 27515,
        softDeleted: false,
        source: "API",
        uniqueId: "L0497",
    },
    {
        content: {
            id: 502837,
            locationId: "NA",
            locationType: "District Office",
            name: "Alexandria Network Operations",
            nickname: null,
            locationInformationUrl: null,
            preferUsersLocation: false,
            geolocation: null,
            region: null,
            physicalAddress: null,
            emergencyAddress: null,
            supervisor: null,
            softDeleted: false,
            source: "API",
            dataSourceId: 1301,
            lastModifiedDate: "2020-06-24T01:12:51.089389Z",
        },
        dataSourceId: 1301,
        id: 502837,
        softDeleted: false,
        source: "API",
        uniqueId: "NA",
    },
]);
//# sourceMappingURL=workLocations.js.map